import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { InfoMenuComponent } from './views/info-menu/info-menu.component';
import { DishComponent } from './views/dish/dish.component';

const routes: Routes = [
  {
    path: '', component: HomeComponent  
  },
  {
    path: 'menu/:idRestaurant/:idMenu/:option', component: InfoMenuComponent
  },
  {
    path: 'detail', component: DishComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
